// 国际化系统入口
import { reactive, watch } from 'vue'
import zhCN from './zh-CN'
import zhTW from './zh-TW'

// 语言映射
const locales = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
}

// 从 localStorage 读取初始语言偏好
const savedLang = typeof localStorage !== 'undefined'
  ? localStorage.getItem('language') || 'zh-TW'
  : 'zh-TW'

// 创建响应式状态
const state = reactive({
  currentLocale: savedLang,
  locale: locales[savedLang],
})

// 监听语言变化，持久化到 localStorage
watch(
  () => state.currentLocale,
  (newLang) => {
    if (locales[newLang]) {
      state.locale = locales[newLang]
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('language', newLang)
      }
    }
  }
)

// 翻译函数：支持嵌套路径如 'nav.home'
function t(path) {
  const keys = path.split('.')
  let result = state.locale
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key]
    } else {
      return path // 找不到翻译时返回原始 key
    }
  }
  return result
}

// 切换语言
function toggleLanguage() {
  state.currentLocale = state.currentLocale === 'zh-CN' ? 'zh-TW' : 'zh-CN'
}

// 获取当前语言
function getCurrentLanguage() {
  return state.currentLocale
}

// 判断是否为繁体中文
function isTraditional() {
  return state.currentLocale === 'zh-TW'
}

export { t, toggleLanguage, getCurrentLanguage, isTraditional, state }
